import echarts from 'echarts';
import fa from 'element-ui/src/locale/lang/fa';
import { config } from '@/views/home/chartJs/chartCommon';

export default function drawBar(params) {
  let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, legend, xAxis } = config;
  let dimensions = [];
  for (let i in params.data[0]) {
    dimensions.push(i);
  }
  let series = [];
  params?.names.forEach((item, i) => {
    series.push({
      type: 'bar',
      name: item,
      barWidth: 10,
      // barGap: 0,//柱间距离
      itemStyle: {
        normal: {
          show: true,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: barColor[i],
            },
            {
              offset: 0.9,
              color: barColorOpacity[i],
            },
          ]),
          borderWidth: 1,
          borderColor: barColor[i],
        },
      },
    });
  });

  let option = {
    dataset: {
      dimensions,
      source: params.data,
    },
    // backgroundColor: '#091C3D',
    tooltip: {
      ...tooltip,
      confine: true,
    },
    legend,
    grid: {
      left: 10,
      top: '20%',
      right: 10,
      bottom: 0,
      containLabel: true,
    },
    xAxis,
    yAxis: [
      {
        ...config.yAxis[0],
        name: params.yAxis.names[0],
      },
      {
        ...config.yAxis[0],
        name: params.yAxis.names[1],
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        type: 'line',
        name: params.names[0],
        yAxisIndex: 1,
        // symbol: 'none',
        symbolSize: 1,
        label: {
          show: true,
          position: 'top',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
        },
        itemStyle: {
          color: '#58ECAC',
        },
      },
      {
        type: 'line',
        name: params.names[1],
        yAxisIndex: 1,
        // symbol: 'none',
        symbolSize: 1,
        label: {
          show: true,
          position: 'top',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
        },
        itemStyle: {
          color: '#fcf5c2',
        },
      },
      {
        type: 'bar',
        name: params.names[2],
        barWidth: 10,
        // barGap: 0,//柱间距离
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[0],
              },
              {
                offset: 0.9,
                color: barColorOpacity[0],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[0],
          },
        },
      },
      {
        type: 'bar',
        name: params.names[3],
        barWidth: 10,
        // barGap: 0,//柱间距离
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[1],
              },
              {
                offset: 0.9,
                color: barColorOpacity[1],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[1],
          },
        },
      },
    ],
  };
  console.log(6566, option);
  return option;
}
